(function () {
  'use strict';

  var script = document.currentScript;
  var SECTION_ID = script && script.dataset.sectionId;
  var SLIDE_COUNT = Number(script && script.dataset.slideCount) || 0;

  /* ── GSAP check (geladen global via animations.min.js) ── */
  function withGSAP(cb) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      cb();
    }
  }

  /* ── Init ─────────────────────────────────────────── */
  function initSection() {
    var section    = document.getElementById('acm-' + SECTION_ID);
    if (!section)  return;

    var viewport   = section.querySelector('.acm-viewport');
    var slides     = Array.from(section.querySelectorAll('.acm-slide'));
    var indicators = Array.from(section.querySelectorAll('.acm-indicator'));
    var indicatorStrip = section.querySelector('.acm-indicators');
    var clipRects  = slides.map(function (_, i) {
      return document.getElementById('acm-rect-' + SECTION_ID + '-' + i);
    });

    /* Per-slide copy text-reveal (data-scroll="manual" – see markup). Played
       from the pin timeline the moment that slide's clip-mask has fully
       opened, so each reveal runs as its slide lands rather than all of
       them firing at once when the section pins. */
    var reveals     = slides.map(function (slide) {
      return slide.querySelector('academy-text-reveal');
    });
    var revealPlayed = slides.map(function () { return false; });

    /* Optional rounded panel behind each slide's copy text — revealed
       (scaleX 0 -> 1 from centre, via the .is-revealed class + CSS
       transition) when that slide's clip-mask has fully opened. Fully
       independent of the text-reveal option; when both are on, the panel
       goes first and the text reveal is held back until it lands. */
    var copyBgs   = slides.map(function (slide) {
      return slide.querySelector('[data-acm-copy-bg]');
    });
    var copyBgShown = slides.map(function () { return false; });
    // Matches the .acm-copy-bg CSS transition duration below.
    var COPY_BG_REVEAL_S = 0.55;

    if (!slides.length) return;

    var isBoxed      = section.dataset.layout === 'boxed';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var acmIsMobile  = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    var mainTL, resizeTimer;

    /* Desktop nav height – measured from element (reliable at init + resize) */
    function desktopNavH() {
      if (window.innerWidth < 1068) return 0;
      var el = document.querySelector('.header-section');
      return el ? Math.round(el.getBoundingClientRect().height) : 112;
    }

    function geometry() {
      var vw = viewport.clientWidth  || window.innerWidth;
      var vh = viewport.clientHeight || window.innerHeight;
      var cx = vw / 2, cy = vh / 2;
      var bw = Math.round(vw * 0.60);
      var bh = Math.round(bw * 0.34);
      return {
        vw: vw, vh: vh, cx: cx, cy: cy,
        blob: { x: cx - bw / 2, y: cy - bh / 2, w: bw, h: bh, rx: bh / 2 },
        full: { x: -4, y: -4, w: vw + 8, h: vh + 8, rx: 0 }
      };
    }

    /* ── Tagline: drop-in-from-above (fake-gravity ease) reveal, then a
       split-flap/scoreboard text swap per active slide ──
       Persistent, section-wide pill (see markup above, outside any
       .acm-slide) that's already fully revealed BEFORE the pin engages —
       triggered purely by scrolling the section into view (top of section
       reaches the vertical middle of the viewport), independent of the
       pin/clip-path timeline below. Runs once.
       Its TEXT can optionally differ per slide (block.settings.tagline_
       override, falling back to the section's default tagline) — every
       slide's row sits stacked in the markup, .acm-tagline-clip masks that
       down to exactly one row's height, and updateTaglineStack (called
       from the pin's onUpdate below, alongside the other per-slide syncs)
       slides the stack so the active slide's row lands in the visible
       window — same mechanic as ACADEMY USP List's pill. */
    var taglineTrigger = null;
    var taglineStack = null;
    var taglineRows = [];
    var taglineIndex = -1;

    // "Fake gravity": a steep, near-vertical drop for the first ~40% of the
    // curve (free-fall), landing hard, then two progressively smaller
    // rebounds — a cheap bounce-physics approximation entirely in the
    // ease curve rather than a real physics sim.
    var GRAVITY_EASE_ID = 'acm-gravity-bounce';
    if (typeof CustomEase !== 'undefined') {
      gsap.registerPlugin(CustomEase);
      // Free-fall accel → overshoot slightly past the target (1.05, i.e.
      // ~4px below its resting spot) → one clear light rebound to 0.9 →
      // a tiny second rebound → settle. Reads as "dropped in, bounced".
      CustomEase.create(GRAVITY_EASE_ID, 'M0,0 C0.18,0 0.3,1.05 0.44,1.05 C0.52,1.05 0.58,0.9 0.66,0.9 C0.73,0.9 0.8,1.02 0.87,1.02 C0.92,1.02 0.96,0.99 1,1');
    }
    var gravityEase = typeof CustomEase !== 'undefined' ? GRAVITY_EASE_ID : 'bounce.out';

    function updateTaglineStack(index) {
      if (!taglineStack || !taglineRows.length) return;
      var row = taglineRows[index] || taglineRows[0];
      if (!row || index === taglineIndex) return;
      taglineIndex = index;
      var targetY = -(row.offsetTop - taglineRows[0].offsetTop);
      if (reduceMotion) {
        gsap.set(taglineStack, { y: targetY });
      } else {
        gsap.to(taglineStack, { y: targetY, duration: 0.5, ease: 'power4.inOut' });
      }
    }

    function initTaglineReveal() {
      var zone = section.querySelector('[data-acm-tagline]');
      if (!zone) return;
      var pill = zone.querySelector('[data-acm-tagline-pill]');
      taglineStack = zone.querySelector('[data-acm-tagline-stack]');
      taglineRows  = taglineStack ? Array.from(taglineStack.querySelectorAll('.acm-tagline-row')) : [];
      if (!pill || !taglineRows.length) return;

      // Land on the first slide's row immediately, no animation — only the
      // pill's own drop-in should be visible; the stack itself must never
      // be seen sliding into its starting position.
      taglineIndex = -1;
      gsap.set(taglineStack, { y: 0 });
      taglineIndex = 0;

      // Start ~72px above its resting spot, already at its oversized scale
      // (1.2). transformOrigin '50% 100%' anchors the scale to the pill's
      // BOTTOM edge, so the oversize bulges sideways/downward only, never
      // upward — that upward bulge was what kept dipping into
      // .acm-viewport's rounded top-left corner and showing a clipped rim
      // even after the fall itself was fixed. No opacity trick: if the
      // trigger somehow never fires the pill is still just 72px too high
      // and 1.2x too big, not invisible.
      gsap.set(pill, {
        y: reduceMotion ? 0 : -72,
        scale: reduceMotion ? 1 : 1.2,
        transformOrigin: '50% 100%'
      });

      function playReveal() {
        // Muted pre-reveal look (grayscale background, midnight-blue
        // indicators — see CSS) ends the instant the pill starts
        // dropping in, not once it's fully landed — the un-graying and
        // the fall read as one single "wake up" moment.
        section.setAttribute('data-acm-revealed', 'true');

        if (reduceMotion) {
          gsap.set(pill, { y: 0, scale: 1 });
          return;
        }
        // Two distinct beats, not one blended tween: the pill falls all
        // the way down FIRST, still at its oversized 1.2 scale throughout
        // (gravity bounce, see gravityEase) — only once it has fully
        // landed, after a 0.2s pause, does it shrink back down to its
        // normal size.
        var tl = gsap.timeline({ delay: 0.3 });
        tl.to(pill, { y: 0, duration: 0.9, ease: gravityEase })
          .to(pill, { scale: 1, duration: 0.35, ease: 'power2.out' }, '+=0.2');
      }

      taglineTrigger = ScrollTrigger.create({
        trigger: section,
        // Fire once the section actually fills the viewport (it pins here),
        // not while it's still scrolling up from the bottom half — that's
        // why the fall wasn't being seen.
        start: 'top 15%',
        once: true,
        onEnter: playReveal,
        // A browser can restore an anchor/history position inside this
        // section without passing through onEnter. In that case render the
        // completed state directly; never change the page scroll position.
        onRefresh: function (self) {
          if (self.scroll() < self.start) return;
          section.setAttribute('data-acm-revealed', 'true');
          gsap.set(pill, { y: 0, scale: 1 });
        }
      });
    }

    /* Indicators stay midnight-blue until the expanding clip-mask has
       actually grown down far enough to sit over the indicator strip —
       while the mask is still a small shape in the centre of the viewport
       there's nothing covering the bars for them to belong to.
       Slide 0's clip-rect is the base layer: it's the frontmost shape
       while it opens and then stays full-screen underneath every later
       slide, so once ITS bottom edge reaches the strip, the strip is
       covered for the rest of the pin (and this reverses correctly when
       scrubbing back up). The rect's attrs are authored in slide ==
       viewport coordinates; rotation only pushes the real edge lower, so
       the axis-aligned check flips, if anything, a touch late. */
    function updateMaskState() {
      var masked = false;
      var rect = clipRects[0];
      if (rect && indicatorStrip) {
        var my = parseFloat(rect.getAttribute('y'))      || 0;
        var mh = parseFloat(rect.getAttribute('height')) || 0;
        var sRect = indicatorStrip.getBoundingClientRect();
        var vRect = viewport.getBoundingClientRect();
        masked = (my + mh) >= (sRect.top - vRect.top);
      }
      section.setAttribute('data-acm-masked', masked ? 'true' : 'false');
    }

    function updateIndicators(raw) {
      var active = Math.min(Math.floor(raw), SLIDE_COUNT - 1);
      var local  = raw - active;
      indicators.forEach(function (ind, i) {
        var fill = ind.querySelector('.acm-indicator__fill');
        if      (i < active)  { fill.style.setProperty('--fill', '1');              ind.dataset.state = 'done';   }
        else if (i === active){ fill.style.setProperty('--fill', local.toFixed(4)); ind.dataset.state = 'active'; }
        else                  { fill.style.setProperty('--fill', '0');              ind.dataset.state = '';       }
      });
    }

    function syncVideo(active) {
      slides.forEach(function (slide, i) {
        slide.querySelectorAll('video').forEach(function (v) {
          if (i === active) { v.play().catch(function () {}); } else { v.pause(); }
        });
      });
    }

    /* clip-path only hides slides visually — without this, assistive tech
       reads every slide's headline/text back to back regardless of which
       one is actually visible. */
    function syncA11y(active) {
      slides.forEach(function (slide, i) {
        if (i === active) { slide.removeAttribute('aria-hidden'); slide.removeAttribute('inert'); }
        else               { slide.setAttribute('aria-hidden', 'true'); slide.setAttribute('inert', ''); }
      });
    }

    /* Fire each slide's copy reveal once its clip-mask has fully opened.
       Slide i animates over timeline segment [i, i+1] (raw = progress *
       SLIDE_COUNT); it fully covers the viewport at raw = i + 1. The last
       slide never gets a "+1" (it's the end of the scroll), so its
       threshold is clamped just short of the timeline end. */
    function maybePlayReveals(raw) {
      for (var i = 0; i < slides.length; i++) {
        if (raw < Math.min(i + 1, SLIDE_COUNT - 0.02)) continue;

        // 1. Copy background panel — independent of the custom element,
        //    always fires (the CSS transition covers reduced-motion —
        //    worst case it just appears).
        var bg = copyBgs[i];
        if (bg && !copyBgShown[i]) {
          copyBgShown[i] = true;
          bg.classList.add('is-revealed');
        }

        // 2. Text reveal — held back until the panel has finished when
        //    both are present, otherwise plays immediately. Custom
        //    element may not be upgraded yet (no GSAP/SplitText,
        //    reduced-motion) — skip and keep polling on the next update.
        var el = reveals[i];
        if (el && !revealPlayed[i] && typeof el.playReveal === 'function') {
          revealPlayed[i] = true;
          if (bg) {
            (function (reveal) {
              if (typeof gsap !== 'undefined') {
                gsap.delayedCall(COPY_BG_REVEAL_S, function () { reveal.playReveal(); });
              } else {
                setTimeout(function () { reveal.playReveal(); }, COPY_BG_REVEAL_S * 1000);
              }
            })(el);
          } else {
            el.playReveal();
          }
        }
      }
    }

    // One canonical state update for live scrolling, anchor/history restores
    // and refreshes caused by another pinned section. It derives every
    // visible/accessible slide from ScrollTrigger's current progress and
    // never changes window scroll position.
    function syncScrollState(self, force) {
      if (!self || (!force && acmStGateIdle)) return;
      var raw    = self.progress * SLIDE_COUNT;
      var active = Math.min(Math.floor(raw), SLIDE_COUNT - 1);
      updateMaskState();
      updateIndicators(raw);
      syncVideo(active);
      syncA11y(active);
      updateTaglineStack(active);
      maybePlayReveals(raw);
    }

    function setup() {
      if (mainTL) {
        if (mainTL.scrollTrigger) mainTL.scrollTrigger.kill();
        mainTL.kill();
      }

      var geo  = geometry();
      var blob = geo.blob, full = geo.full;
      var cx   = geo.cx,  cy   = geo.cy;
      var svo  = cx + ' ' + cy;

      // Force the next updateTaglineStack call to re-measure and re-apply
      // the active row's offset — a resize can land on a new breakpoint
      // (the pill's font-size, and so every row's height/offsetTop,
      // changes at media-md), and without this the active index staying
      // the same across that resize would skip re-syncing to the new
      // geometry, leaving the pill's text stack misaligned.
      taglineIndex = -1;

      /* ── Initial states ──────────────────────────── */
      for (var k = 0; k < SLIDE_COUNT; k++) {
        if (clipRects[k]) {
          gsap.set(clipRects[k], {
            attr:      { x: blob.x, y: blob.y, width: blob.w, height: blob.h, rx: blob.rx },
            svgOrigin: svo, rotation: -21.5, scale: 0
          });
        }
      }

      /* ── Timeline ────────────────────────────────── */
      var navH      = isBoxed ? desktopNavH() : 0;
      var startPos  = navH > 0 ? ('top top+=' + navH) : 'top top';

      mainTL = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          pin:     true,
          scrub:   acmIsMobile ? 0.3 : 0.5,
          start:   startPos,
          // Mobile: one full screen of travel per slide (matches desktop),
          // plus snap, so one firm swipe advances one slide and settles on
          // it. A shorter travel (previously ~0.62 screen) made a single
          // swipe cover most or all of a slide's clip-mask animation at
          // once — the text reveal (which only fires once a slide has
          // fully opened) barely had time to show before the next slide's
          // mask started drawing on top of it.
          end:     function () {
            var vh = viewport.clientHeight || window.innerHeight;
            return '+=' + (SLIDE_COUNT * vh);
          },
          snap: acmIsMobile && SLIDE_COUNT > 1 ? {
            snapTo: 1 / (SLIDE_COUNT - 1),
            duration: { min: 0.15, max: 0.35 },
            delay: 0.04,
            ease: 'power1.inOut'
          } : false,
          onUpdate: function (self) {
            syncScrollState(self, false);
          },
          onRefresh: function (self) {
            syncScrollState(self, true);
          }
        }
      });

      /* Phase 1 (0–70%): pill scales from 0 → 1 — perfect shape at every size.
         Phase 2 (70–100%): blob expands to full screen, rotation and rx removed.
         With prefers-reduced-motion: reduce, tween durations collapse to 0 —
         the scroll-linked slide switching (pin + story progression) stays
         functional, but the rotating/scaling blob motion itself is removed. */
      var d1 = reduceMotion ? 0 : 0.7;
      var d2 = reduceMotion ? 0 : 0.3;

      function addSlide(i, pos) {
        var rect = clipRects[i];
        if (!rect) return;

        mainTL.fromTo(rect,
          { attr: { x: blob.x, y: blob.y, width: blob.w, height: blob.h, rx: blob.rx }, svgOrigin: svo, rotation: -21.5, scale: 0 },
          { svgOrigin: svo, rotation: -21.5, scale: 1, ease: 'none', duration: d1 },
          pos
        );

        mainTL.fromTo(rect,
          { attr: { x: blob.x, y: blob.y, width: blob.w, height: blob.h, rx: blob.rx }, svgOrigin: svo, rotation: -21.5, scale: 1 },
          { attr: { x: full.x, y: full.y, width: full.w, height: full.h }, svgOrigin: svo, rotation: 0, scale: 1, ease: 'none', duration: d2 },
          pos + d1
        );

        mainTL.fromTo(rect,
          { attr: { rx: blob.rx } },
          { attr: { rx: 0 }, ease: 'none', duration: d2 },
          pos + d1
        );
      }

      for (var j = 0; j < SLIDE_COUNT; j++) {
        addSlide(j, j);
      }

      // Force an immediate re-measure + re-render at the CURRENT scroll
      // position right after (re)building the trigger. Without this, a
      // rebuild triggered by resize can leave every clip-rect sitting in
      // the "reset" blob/scale:0 state from the loop above for a frame (or
      // longer, if ScrollTrigger's own lazy render happens to land on a
      // stale measurement) — which is what read as the image/container
      // not filling the viewport after a resize.
      if (mainTL.scrollTrigger) {
        mainTL.scrollTrigger.refresh();
        syncScrollState(mainTL.scrollTrigger, true);
      }
    }

    setup();
    initTaglineReveal();

    new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) {
        section.querySelectorAll('video').forEach(function (v) { v.pause(); });
      }
    }, { threshold: 0 }).observe(section);

    /* onUpdate cost gate: while the section is ≥1 viewport out of view, just
       SKIP the heavy per-frame work (see the acmStGateIdle check at the top
       of the timeline's onUpdate). The pinned ScrollTrigger itself stays
       enabled + measured — previously it was disable(false)'d and
       enable()+refresh()'d on approach, but on a fast mobile scroll the
       IntersectionObserver fires late, so the pin could still be disabled
       when the section was reached → scrolled in un-pinned, then snapped
       back ("hängt" / nicht sofort), plus the mid-scroll refresh() hitch. */
    var acmStGateIdle = false;
    new IntersectionObserver(function (entries) {
      acmStGateIdle = !entries.some(function (e) { return e.isIntersecting; });
    }, { rootMargin: '100% 0px 100% 0px' }).observe(section);

    // Only react to a REAL viewport change — a width change (rotation,
    // desktop resize). A height-only 'resize' is the iOS/Android address
    // bar showing or hiding mid-scroll; rebuilding the pinned ScrollTrigger
    // (kill + recreate) on that shifts the pin's measured range while the
    // user is still scrolling, which is what read as randomly jumping to a
    // different section (see academy-parallax-scroll.js's onViewportChange
    // for the same fix applied there first).
    var acmLastW = window.innerWidth;
    function onResize() {
      if (window.innerWidth === acmLastW) return;
      acmLastW = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 250);
    }
    window.addEventListener('resize', onResize);

    document.addEventListener('shopify:section:unload', function (event) {
      if (event.detail && event.detail.sectionId === SECTION_ID) {
        clearTimeout(resizeTimer);
        window.removeEventListener('resize', onResize);
        if (mainTL) {
          if (mainTL.scrollTrigger) mainTL.scrollTrigger.kill();
          mainTL.kill();
        }
        if (taglineTrigger) taglineTrigger.kill();
      }
    });
  }

  function boot() {
    withGSAP(initSection);
    // No animation library available — initSection never runs, so make
    // sure any optional copy-text background panels are still shown
    // (they default to scaleX(0), revealed by the pin timeline otherwise).
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      var sec = document.getElementById('acm-' + SECTION_ID);
      if (sec) {
        sec.querySelectorAll('[data-acm-copy-bg]').forEach(function (bg) {
          bg.classList.add('is-revealed');
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
